import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { getApplicationInstance } from '../core/Application';

export default function registerGSAPPlugins() {
    gsap.registerPlugin(ScrollTrigger);

    const applicationInstance = getApplicationInstance();
    applicationInstance.registerGSAP(gsap, ScrollTrigger);
}
